import { createStore } from "vuex" 

const store = createStore({
   state:{
      name: "Vue"
   }
})

export default store